<script>
import ComiteConvivencia from "@/components/estandares/Comite/comite-convivencia";
import ActaGeneral from "@/components/standard/Comite/actas-general";
import ActAPI from "@/services/standards/committee/acts/actAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import Swal from "sweetalert2";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Comité de convivencia",
  },
  components: {
    ComiteConvivencia,
    ActaGeneral,
    CheckModal,
  },
  data() {
    return {
      title: "Comité de Convivencia",

      selected: {
        code: null,
        created_at: null,
        deleted_at: null,
        id: 1,
        name: "Listado de Actas",
        status: 1,
        updated_at: "2022-07-19T18:09:30.000000Z",
      },
      list: [],
      company: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      file: null,
      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      lastId: 1,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(8)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getTypes() {
      ActAPI.getTypes()
        .then((response) => {
          let list = response;
          list.unshift({
            code: null,
            created_at: null,
            deleted_at: null,
            id: 1,
            name: "Listado de Actas",
            status: 1,
            updated_at: "2022-07-19T18:09:30.000000Z",
          });
          this.loading1 = false;
          this.list = list;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    print() {
      const base =
        "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/";
      const formatos = {
        "1.1.8.1": "ACTA_CONSTITUCION_COMITE_CONVIVENCIA.docx",
        "1.1.8.2": "ACTA_CONVOCATORIA_INSCRIPCION_COMITE_CONVIVENCIA.docx",
        "1.1.8.3": "ACTA_DESIGNACION_CONFORMACION_MENOS_5_TRABAJADORES.docx",
        "1.1.8.4": "ACTA_REUNION_MENSUAL_COMITE_CONVIVENCIA.docx",
        "1.1.8.5": "ACTA_APERTURA_CIERRE_ELECCIONES_COMITE_CONVIVENCIA.docx",
        "1.1.8.6": "FORMATO_REGISTRO_VOTOS_COMITE_CONVIVENCIA.docx",
        "1.1.8.7": "FORMATO_INSCRIPCION_COMITE_CONVIVENCIA.docx",
        "1.1.8.8": "INFORME_TRIMESTRAL_COMITE_CONVIVENCIA.docx",
        "1.1.8.9": "MANUAL_CONVIVENCIA_LABORAL.docx",
        "1.1.8.10": "POLITICA_CONVIVENCIA_LABORAL_PREVENCION_ACOSO.docx",
        "1.1.8.11": "PROCEDIMIENTO_ATENCION_QUEJAS_COMITE_CONVIVENCIA.docx",
      };
      const archivo = formatos[this.selected.code];
      if (archivo) {
        window.location.href = base + archivo;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.8/act-id${this.selected.id}/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.8/act-id${this.selected.id}/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      try {
        this.submitted = true;
        this.loading1 = true
        let response = await this.uploadDocument();
        if (response) {
          ActAPI.save(this.companyID, this.selected.id, this.file)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 8,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading1 = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡success!",
                      text: "¡Se ha registrado con éxito!",
                      icon: "success",
                      type: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 2000)
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            }).catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        } else {
          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡error!",
              text: "¡No se ha podido cargar el documento!",
              icon: "error",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 1500)
        }
      } catch (error) {
        console.log(error);
      }
    },

    getLastId() {
      ActAPI.get(this.companyID, '')
        .then((resp) => {
          if (resp.message[0]['id']) {
            this.lastId = resp.message[0]['id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },


    /**
     * This method is used to get the company data.
     */
    getCompany() {
      CompanyAPI.getCompany(this.companyID)
        .then((res) => {
          CompanySSOAPI.getCompany(res.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((err) => {
              console.log("SSO Company error: ", err);
            });
        })
        .catch((err) => {
          console.log("Company error: ", err);
        });
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(id = 8) {
      CompanyItemsAPI.getStatus(this.companyID, id)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 8)
        .then((response) => {
          try {
            this.item = response || null;
            this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          } catch (error) {
            console.log(error);
            this.item = null;
            this.itemStatus = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 8,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getLastId();
    this.getCompany();
    this.getTypes();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <div v-if="!loading1">
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <CheckModal>
          <p class="text-justify">
            La empresa debe contar con un comité de convivencia laboral, el
            cual deberá contar con 4 representantes en empresas de menos de 20
            trabajadores y de 8 para empresas de más de 20. <br /><br />
            Este comité es el encargado de apoyar a la empresa en la
            generación de buenos ambientes laborales, así como de atender las
            posibles situaciones de acoso laboral que se presenten.
            <br /><br />
            Se deberá reunir cada 3 meses, elaborar actas de dichas reuniones
            y elaborar informes trimestrales con la gestión realizada.
          </p>
        </CheckModal>
      </div>
      <div class="col-md-6 col-sm-12">
        <a :href="`/forms/convivencia`" underline class="mx-1">
          ¿Qué es el Comité de Convivencia?
        </a>
      </div>
      <div class="col-12 text-right m-b-0">
        <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
        </div>
        <b-tooltip target="back" placement="left"> Volver </b-tooltip>
      </div>
    </div>

    <div class="form-row col-md-6 col-sm-12 pt-1">
      <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
        <b-form-select v-on:change="changeItemStatus(itemStatus)"
          :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
          class="selectpicker form-control" v-model="itemStatus">
          <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
          <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
          <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
        </b-form-select>
      </b-form-group>
    </div>

    <br>
    <form class="form-group" @submit.prevent="save">

      <div class="row">
        <div class="col-md-6 col-sm-12 form-group pt-1 ml-2">
          <label for="datos">Buscar</label>
          <select v-model="selected" class="form-control" id="datos">
            <option v-for="dato in list" :value="dato" :key="dato.id">
              {{ dato.code }}{{ dato.code ? " - " : null }}{{ dato.name }}
            </option>
          </select>
        </div>

        <div v-if="selected.id !== 1 && selected.id !== null"
          class="col-md-6 col-sm-12 form-group ml-2">
          <b-form-group label="Subir acta" label-for="uploadFile">
            <b-form-file :disabled="!allowAccess() || !getRole('Crear')" required type="file" id="file" ref="file"
              name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
              drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
              accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
            </b-form-file>
          </b-form-group>
        </div>
      </div>

      <div v-if="selected.id !== 1 && selected.id !== null" class="form-group text-right">
        <b-button variant="primary" type="button" @click="print" :disabled="!allowAccess()">
          <span class="btn-label"><i class="bx bxs-printer"></i></span>Descargar
        </b-button>

        <button :disabled="submitted" type="submit" class="btn btn-primary m-l-5 ml-1">Guardar</button>
        <button type="reset" class="btn btn-secondary m-l-5 ml-1" v-on:click="goBack">Cancelar</button>
      </div>

    </form>

    <hr />

    <div v-if="selected.id === 1 && getRole('Consultar')">
      <ActaGeneral />
    </div>
  </div>

  <div v-else>
    <div class="text-center">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
